module.exports = __webpack_public_path__ + "img/login_img.19a972d6.png";